/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tutorial_VideosInputs */



/**
* | output |
* | --- |
* | "Tutorial Videos" |
*
* @param {Tutorial_VideosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tutorial_videos = /** @type {((inputs?: Tutorial_VideosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tutorial_VideosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vidéos tutoriels")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tutorial-Videos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Video tutorial")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеоуроки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vídeos tutoriales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("教程视频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チュートリアルビデオ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्यूटोरियल वीडियो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Vídeos tutoriais")
	return /** @type {LocalizedString} */ ("Tutorial Videos")
});